import functions from './functions';
import Slider from './components/Slider';
import { FormGuide } from "./components/form-guide.js";
import { DeparturePicker } from "./components/departure-picker.js";
import { DeparturePickerCombined } from "./components/departure-picker-combined.js";
import { InputGuests } from "./components/input-guests";
import { Select2 } from './components/select2.js';

$(() => {

    $('.btn-print-other').on('click', e => {
        const $content = $('.other-page-content').clone();
        $content.find('.btn-print-other').remove();
        const content = $content[0];

        const $head = $('head');
        const head = $head[0];

        let htmlToPrint = head.outerHTML + '<style>@page { size:  auto; margin-top: 60px; margin-bottom: 60px; }</style>' + '<body>' + content.outerHTML + '</body>';
        let windowToPrint = window.open("");

        windowToPrint.document.write(htmlToPrint);
        setTimeout(() => {
            windowToPrint.print();
            windowToPrint.close();
        }, 500);
    });

    // active menu item
    const navItemLevel3 = $('.nav-item-level-3[href="' + window.location.pathname + '"]');
    if (navItemLevel3.length && ! navItemLevel3.hasClass('active')) {
        navItemLevel3.addClass('active');
    }

    const isMobile = functions.isMobile();

    const $scrollFadeTop = $('.scroll-fade-top');

    function scrollFadeTop() {
        const scrollTop = $(window).scrollTop();

        $scrollFadeTop.length && $scrollFadeTop.each((index, elem) => {
        const $elem = $(elem);

        if($elem.length && ! $elem.hasClass('start-animation') && ($elem.offset().top - scrollTop) < (functions.isMobile() ? 650 : 750)) {
            $elem.addClass('start-animation');
        }
        });
    }

    scrollFadeTop();

    if ($(window).scrollTop() > 80) {
        $('.main-header').addClass('following');
        $('.btn-scroll-top').addClass('show');
    }

    $(window).scroll(e => {
        scrollFadeTop();

        $(window).scrollTop() > 10
            ? $('.main-header').addClass('following')
            : $('.main-header').removeClass('following');

        $(window).scrollTop() > 80
            ? $('.btn-scroll-top').addClass('show')
            : $('.btn-scroll-top').removeClass('show');
    });

    $('#navMainMenu').on('show.bs.collapse', e => {
        $('.navbar').addClass('show');
    });
    
    $('#navMainMenu').on('hide.bs.collapse', e => {
        $('.navbar').removeClass('show');
    });

    // card-newsletter
    /*$('.card-newsletter').on('click', e => {
        const $target = $(e.currentTarget);
        const hasLink = $target.attr('href');

        if (! hasLink)
        {
            e.preventDefault();
            e.stopPropagation();
        }
    });*/

    const $heroSlider = $('#hero-slider');

    if ( $heroSlider.length ) {    
        $heroSlider._slider = new Slider($heroSlider, {
            fade: true,
            rubberband: false,
            loop: true,
            arrows: true,
            pager: false,
            //autoplay: 4000,
            slides: {
                perView: 1,
                spacing: 0
            },
            defaultAnimation: {
                duration: 0
            },
            detailsChanged: (s) => {
                s.slides.forEach((element, idx) => {
                    if ( s.track.details.slides[idx].portion == 0 ) {
                    element.style.opacity = 0;
                    }
                    if ( s.track.details.slides[idx].portion == 1 ) {
                    element.style.opacity = 1;
                    }
                });

                let slideNo = +s.track.details.rel + 1;
                //slideNo = slideNo < 10 ? '0' + slideNo : slideNo;
                slideNo = slideNo < 10 ? slideNo : slideNo;

                setTimeout(() => $heroSlider._slider.$arrows.find('.current-slide').text(slideNo));
            },
            renderMode: "custom",
        });
        $heroSlider.find('.keen-slider__slide').first().addClass('active');

        const slider = $heroSlider._slider.instance;
        let slideTotal = slider.slides.length;
        //slideTotal = slideTotal < 10 ? '0' + slideTotal : slideTotal;
        slideTotal = slideTotal < 10 ? slideTotal : slideTotal;

        $heroSlider._slider.$arrows.find('[data-dir="prev"]').after(
            `<div class="slider-counter">
                <div class="current-slide"></div>
                <div class="count-separator">/</div>
                <div class="slider-total">${slideTotal}</div>
            </div>`
        );
    }

    const $contentSlider = $('#content-slider');

    if ( $contentSlider.length ) {  
        // foreach $contentSlider 
        $contentSlider._slider = new Slider($contentSlider, {
            fade: false,
            rubberband: false,
            loop: true,
            arrows: true,
            pager: false,
            //autoplay: 4000,
            slides: {
                perView: 1,
                spacing: 0
            },
            defaultAnimation: {
                duration: 0
            },
            detailsChanged: (s) => {
                /*s.slides.forEach((element, idx) => {
                    if ( s.track.details.slides[idx].portion == 0 ) {
                    element.style.opacity = 0;
                    }
                    if ( s.track.details.slides[idx].portion == 1 ) {
                    element.style.opacity = 1;
                    }
                });*/

                let slideNo = +s.track.details.rel + 1;
                //slideNo = slideNo < 10 ? '0' + slideNo : slideNo;
                slideNo = slideNo < 10 ? slideNo : slideNo;

                setTimeout(() => $contentSlider._slider.$arrows.find('.current-slide').text(slideNo));
            },
            //renderMode: "custom",
        });
        $contentSlider.find('.keen-slider__slide').first().addClass('active');

        const slider = $contentSlider._slider.instance;
        let slideTotal = slider.slides.length;
        //slideTotal = slideTotal < 10 ? '0' + slideTotal : slideTotal;
        slideTotal = slideTotal < 10 ? slideTotal : slideTotal;

        $contentSlider._slider.$arrows.find('[data-dir="prev"]').after(
            `<div class="slider-counter">
                <div class="current-slide"></div>
                <div class="count-separator">/</div>
                <div class="slider-total">${slideTotal}</div>
            </div>`
        );
    }

    let listSlider = [];
    $('[id^=list-slider]').each((i, elem) => {
        const length = $(elem).find('.keen-slider__slide').length;

        listSlider[i] = new Slider('#' + $(elem).attr('id'), {
            rubberband: false,
            loop: true,
            arrows: true,
            spacing: 0,
            pager: true,
            drag: isMobile,
            slides: {
                perView: 3,
                spacing: 0
            },
            breakpoints: {
            '(max-width: 1920px)': {
                origin: 'center',
                drag: true,
                loop: true,
                slides: {
                    perView: 3,
                    spacing: 0,
                },
            },
            '(max-width: 1360px)': {
                origin: 'center',
                drag: true,
                loop: true,
                slides: {
                    perView: 2.2,
                    spacing: 0,
                },
            },
            '(max-width: 991px)': {
                origin: 'center',
                drag: true,
                loop: true,
                slides: {
                    perView: 2.2,
                    spacing: 0,
                },
            },
            '(max-width: 767px)': {
                origin: 'center',
                drag: true,
                loop: true,
                slides: {
                    perView: 1.1,
                    spacing: 0,
                },
            },
        },
        });

        const $arrows = $(elem).siblings('.keen-slider__arrows');

        if (isMobile && length < 2) {
            $arrows.addClass('d-none');
        } else if (! isMobile && length < 3) {
            $arrows.addClass('d-none');
        } else {
            $arrows.removeClass('d-none');
        }

    });

    $('.select2').each((i, elem) =>{
        elem._select2 = new Select2(elem);
    });

    $('.form-guide').each((i, elem) =>{
        elem._formGuide = new FormGuide(elem);
    });

    $('.datepicker.departure-picker:not(#details-datepicker) [data-input]').each((i, elem) => {
        elem._departurePicker = new DeparturePicker(elem);
    });

    $('.datepicker-range.departure-picker-combined:not(#details-datepicker) [data-input]').each((i, elem) => {
        elem._departurePickerCombined = new DeparturePickerCombined(elem);
    });

    $('[name=dates], [name=dateFrom]').on('change', e => {
        const $target = $(e.currentTarget);
        
        let $datepicker = $target.parents('.datepicker-range');
        
        if($target.parents('.departure-picker').length) {
          $datepicker = $target.parents('.departure-picker');
        } else if ($target.parents('.datepicker-range-inquiry').length) {
          $datepicker = $target.parents('.datepicker-range-inquiry');
        }
        
        $datepicker.length && $datepicker.find('[data-clear]').toggleClass('d-none', ! $target.val());
    });

    $('.input-guests').each((i, elem) => {
        elem._inputGuests = new InputGuests(elem);
    });

    // scrool to element handling
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.currentTarget);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });

    $('.show-more').each( (i, elem) => {
        let $showMore = $(elem);

        if ($showMore.find('.show-more-content').outerHeight() < 150)
        {
            $showMore.addClass('removeBefore');
            $showMore.next('.show-more-expand').remove();
            return;
        }
        let height = $showMore.attr('data-height');
        let $breakpoint = $showMore.find('.show-more-breakpoint');
        if (height)
        {
            $showMore.css('max-height', +height);
        }
        else if ($breakpoint.length) 
        {
            $showMore.css('max-height', $breakpoint.offset().top - $showMore.offset().top - 25);
        }
        else 
        {
            let $maxHeight = functions.isMobile() ? 
                        ($showMore.outerHeight() * 0.15) : 
                        ($showMore.outerHeight() * 0.3);

            $showMore.css('max-height', $maxHeight);
        }
    
        $showMore.next('.show-more-expand').on('click', e => {
            let $prevSibling = $(e.currentTarget).prev();
            let $maxHeight
            if ($prevSibling.hasClass('removeBefore'))
            {
                let height = $prevSibling.attr('data-height');
                let $breakpoint = $prevSibling.find('.show-more-breakpoint');
                if (height)
                {
                    $maxHeight = +height;
                }
                else if ($breakpoint.length) 
                {
                    $maxHeight = $breakpoint.offset().top - $showMore.offset().top - 25;
                }
                else 
                {
                    $maxHeight = functions.isMobile() ? 
                        ($prevSibling.outerHeight() * 0.15) : 
                        ($prevSibling.outerHeight() * 0.3);
                }
                $prevSibling.css('max-height', $maxHeight);
                $prevSibling.removeClass('removeBefore');
                if ($prevSibling.hasClass('show-more-scroll')) 
                {
                    $('html, body').stop().animate({
                        scrollTop: $prevSibling.offset().top + $maxHeight - $(e.target).outerHeight(),
                    }, 0, 'linear');
                }
            }
            else 
            {
                let $content = $prevSibling.find('.show-more-content');
                $prevSibling.css('max-height', $content.outerHeight());
                $prevSibling.addClass('removeBefore');
            }
        })
    });

    $('.btn-level').on('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const $target = $(e.currentTarget);
        $target.toggleClass('show', ! $target.hasClass('show'));
        
        const $sibling = $target.siblings('.dropdown-submenu');
        $sibling.toggleClass('show', ! $sibling.hasClass('show'));
    });
});